<template>
   <Boyo-Dialog :dialogInfo="dialogInfoData"
   @dialogEvent="dialogEventData">
    <div style="display: flex; flex-direction: row; align-items: flex-start;">
      <!-- 左侧竖向步骤条 -->
      <div style="width: 240px; min-width: 220px; margin-right: 24px;">
        <el-steps direction="vertical" :active="activeValue">
          <el-step
            v-for="(item, index) of activeList"
            :key="index"
            :title="item.processNodeName"
            :status="item.stepStatus || 'process'"
          >
            <template slot="description">
              <div v-if="item.processNodeName === '制单人'">
                {{ item.approvalTime }}
              </div>
              <div v-else>
                <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                <div>流程节点：{{ item.processNodeName || '' }}</div>
                <div>经办人：{{ item.maker || '' }}</div>
                <div v-if="item.stepStatus !== 'process'">备注：{{ item.remark || (item.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                <div>时间：{{ item.makerTime || '' }}</div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
      <!-- 右侧内容 -->
      <div style="flex: 1; overflow-x: auto;">
        <!-- 表单部分 -->
        <Boyo-Formtwo
          :formInfo="formInfo"
          :refObj.sync="formInfo.ref"
          :listTypeInfo="listTypeInfo"
        >
        </Boyo-Formtwo>

        <!-- 表格部分 -->
        <div style="width: 100%; overflow-x: auto; margin-top: 20px;">
          <Boyo-Table
            :tableInfo="tableInfo"
            :listTypeInfo="listTypeInfo"
          >
          </Boyo-Table>
        </div>

        <!-- 审核表单 -->
        <div v-if="showAuditForm" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
           <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
          <Boyo-Formtwo
            :formInfo="formInfo2"
            :refObj.sync="formInfo2.ref"
            :listTypeInfo="listTypeInfo"
          >
          </Boyo-Formtwo>
        </div>
      </div>
    </div>
  </Boyo-Dialog>
</template>

<script>
import BoyoFormtwo from '@/components/BoyoFormtwo'
import BoyoTable from '@/components/BoyoTabletwo'
import BoyoDialog from '@/components/BoyoDialog'
import config from '@/api/config'

export default {
  name: 'InternalWeighingDialog',
  components: {
    BoyoFormtwo,
    BoyoTable,
    BoyoDialog
  },
  props: {},
  data() {
    return {
      pingImgUrl: config.pingImgUrl,
      loading: false,
      showAuditForm: false,
      auditTask: null,
      processInstanceId: null,
      makerInfo: '',
      makerTime: '',
      activeValue: 0,
      activeList: [],
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '移库结算单'
        ],
        showPhraseManager: false,
        newPhrase: '',
      
      // 表单信息
      formInfo: {
        ref: null,
        labelWidth: '112px',
        inline: true,
        data: {
          id: '',
          billNo: '',
          billDate: '',
          carNo: '',
          carrierId: '',
          carrierName: '',
          grossWeight: '',
          tareWeight: '',
          netWeight: '',
          materialName: '',
          factoryAreaName: '',
          outStockName: '',
          presentCarNo: '',
          presentDate: '',
          presentNetWeigh: '',
          remark: ''
        },
        list: [
          { type: 'text', label: '车牌号：', value: 'carNo', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '承运商：', value: 'carrierName', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '毛重(吨)：', value: 'grossWeight', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '皮重(吨)：', value: 'tareWeight', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '净重(吨)：', value: 'netWeight', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '物料名称：', value: 'materialName', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '所属单位：', value: 'factoryAreaName', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '出库仓库：', value: 'outStockName', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '到厂车牌：', value: 'presentCarNo', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '到厂日期：', value: 'presentDate', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '到厂净重(吨)：', value: 'presentNetWeigh', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'textarea', label: '备注：', value: 'remark', style: 'width:80%', className: 'form_item_two', disabled: true }
        ],
        rules: {}
      },
      
      // 表格信息
      tableInfo: {
        height: 250,
        selection: false,
        xuhao: true,
        selectReset: null,
        mode: null,
        data: [],
        total: 0,
        pager: false,
        multipleSelection: [],
        fieldList: [
          { value: 'exctTaxPrice', label: '单价(元)', show: true, dropdown: true },
          { value: 'exctTaxAmount', label: '金额(元)', show: true, dropdown: true },
          { value: 'taxPrice', label: '税率(%)', show: true, dropdown: true },
          { value: 'taxAmount', label: '税额(元)', show: true, dropdown: true },
          { value: 'totalAmount', label: '总金额(元)', show: true, dropdown: true },
          { value: 'transportType', label: '运输类型', list:'transportType',show: true, dropdown: true },
          { value: 'settleFlag', label: '结算状态', list:'settleFlag',show: true, dropdown: true },
          { value: 'settleSubmitFlag', label: '结算提交状态', list:'settleSubmitFlag', show: true, dropdown: true }
        ],
        btList: []
      },
      
      // 审核表单
      formInfo2: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          processId: '',
          status: 1,
          remark: '',
          processId:'',
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择' }]
        }
      },
      dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '移库结算单数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
      // 列表类型信息
      listTypeInfo: {
        statusFlag2: [{ value: 1, label: '同意' }, { value: 2, label: '不同意' }],
        transportType:[{value:0,label:'车运'},{value:1,label:'集装箱运'},{value:2,label:'船'}],
        settleFlag:[{ value: 0, label: '未结算' }, { value: 1, label: '已结算' }],
        settleSubmitFlag:[{value:0,label:'未提交'},{value:1,label:'已提交'}],
        processId:[]
      }
    }
  },
  mounted () {

     // 获取流程枚举
     this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for( let i in list1 ) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
  },
  methods: {
    // 显示对话框
    dialogShow(dataId, auditDialog = 0, auditTask = null, processInstanceId = null, maker = '', makerTime = '') {
      this.id = dataId
      this.auditTask = auditTask
      this.processInstanceId = processInstanceId
      this.makerInfo = maker
      this.makerTime = makerTime

      // 审核按钮和表单显示逻辑参照PaymentAdvDetailDialog.vue
      if (auditTask && auditTask.id) {
        this.showAuditForm = true
        this.dialogInfoData.btList[0].show = true
      } else {
        this.showAuditForm = false
        this.dialogInfoData.btList[0].show = false
      }
      // 流程名称回显
      // 抽一个小工具：把 processId 转成 label 或原值
      const setProcessLabel = () => {
        if (!auditTask) return;                 // 没数据直接返回
        const list = this.listTypeInfo.processId || [];
        const hit  = list.find(i => i.enumValue === auditTask.processId);
        this.formInfo2.data.processId = hit ? hit.value : auditTask.processId;
      };
      // 判断下拉数组是否已经就绪
      if (this.listTypeInfo.processId && this.listTypeInfo.processId.length) {
        this.$nextTick(setProcessLabel);        // 已就绪，立即跑
      } else {
        // 没就绪，watch 等它
        const unwatch = this.$watch(
        () => this.listTypeInfo.processId,
        val => {
          if (Array.isArray(val) && val.length) {
            unwatch();                        // 只跑一次就解绑
            setProcessLabel();
          }
        },
        { immediate: true }                   // 防止当前瞬间已经就绪
        );
    }
      // 重置表单数据
      this.resetFormData()
      // 获取数据详情
      this.getWeighingDetails(dataId)
      // 获取审核流程步骤
      if (processInstanceId) {
        this.getProcessSteps(processInstanceId)
      }
      this.dialogInfoData.visible = true
    },
    
    // 重置表单数据
    resetFormData() {
      for (const key in this.formInfo.data) {
        this.formInfo.data[key] = ''
      }
      this.tableInfo.data = []
      
      // 重置审核表单
      if (this.showAuditForm) {
        this.formInfo2.data.status = 1
        this.formInfo2.data.remark = ''
      }
    },
    
    // 获取过磅单详情
    getWeighingDetails(id) {
      this.loading = true
      this.$api.Ship.getStkInternalWeighingPage({ idPurArrival: id }).then(res => {
        this.loading = false
        if (res.code === 0 && res.data.list && res.data.list.length > 0) {
          const data = res.data.list[0]
          
          // 填充表单数据
          for (const key in this.formInfo.data) {
            if (key in data) {
              this.formInfo.data[key] = data[key]
            }
          }
          
          // 填充表格数据
          this.tableInfo.data = [data] // 或者可能需要获取其他相关数据
          this.tableInfo.total = 1
          
          // 发出事件
          this.$emit('approvalInfo')
        } else {
          this.$message({ message: res.msg || '获取数据失败', type: 'error' })
        }
      }).catch(err => {
        this.loading = false
        console.error('获取内转过磅单数据出错：', err)
        this.$message({ message: '获取数据失败', type: 'error' })
      })
    },
    
    // 获取审核流程步骤
    getProcessSteps(processInstanceId) {
      this.$api.system.getActProcessEntryPage({ idProcessInstance: processInstanceId, pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) {
          this.activeList = []
          this.activeValue = 0
          for (let i in res.data.list) {
            if (res.data.list[i].status && i < res.data.list.length) {
              this.activeValue = Number(Number(i) + 1)
            }
            let stepStatus = 'process';
            if (res.data.list[i].status == 1) {
              stepStatus = 'success';
            } else if (res.data.list[i].status == 2) {
              stepStatus = 'error';
            } else {
              stepStatus = 'process';
            }
            this.activeList.push({
              processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
              maker: res.data.list[i].status
                ? res.data.list[i].actualApprover
                : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
              remark: res.data.list[i].remark || '', // 第三行：备注
              makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
              stepStatus
            });
          }
          // 步骤条最前面插入“制单人”节点
          let maker = this.makerInfo || '暂无';
          let makerTime = this.makerTime || '';
          let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
          this.activeList.unshift({ processNodeName: '制单人', approvalTime });
          this.activeValue = (this.activeValue || 0) + 1;
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
            const params = {
            id: this.auditTask.id,
            processId: this.formInfo2.data.processId,
            status: this.formInfo2.data.status,
            remark: this.formInfo2.data.remark
          }
          
          this.loading = true
          this.$api.system.approval(params).then(res => {
            this.loading = false
            if (res.code === 0) {
              this.$message({ message: '审核提交成功', type: 'success' })
              this.dialogInfoData.visible = false
              this.$emit('approvalInfo')
            } else {
              this.$message({ message: res.msg || '审核提交失败', type: 'error' })
            }
          }).catch(err => {
            this.loading = false
            console.error('审核提交出错：', err)
            this.$message({ message: '审核提交失败', type: 'error' })
          })
              break
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    
    
    // 对话框关闭事件
    dialogClosed() {
      this.resetFormData()
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>

<style lang="stylus" scoped>
.dialog-footer
  display flex
  justify-content flex-end

.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style> 


// WEBPACK FOOTER //
// src/components/Custom/InternalWeighingDialog.vue